import { SITE } from "@/data/site"

function Closing() {
  return (
    <section className="relative flex min-h-[70vh] w-full flex-col items-center justify-center bg-[#080808] px-8 py-32 text-center md:min-h-screen">
      <p className="font-sans-ui text-[11px] tracking-[0.48em] text-[#c4a574]">09</p>
      <h2 className="font-display mt-10 whitespace-nowrap text-[clamp(1.35rem,8vw,4.5rem)] italic leading-none tracking-[0.02em] text-[#f7f1e6] md:text-7xl">KEEP THE FEELING.</h2>
      <p className="font-serif-tc mt-10 text-sm tracking-[0.12em] text-stone-400 md:text-xl">{SITE.tagline}</p>
      <img
        src={SITE.closingMark}
        alt="WILD THING"
        className="mt-16 h-auto w-[min(78vw,420px)] mix-blend-screen object-contain md:mt-20 md:w-[480px]"
      />
    </section>
  )
}

export default Closing
